export let Specs = /*#__PURE__*/function (Specs) {
  Specs["BLOCK_TRANSFER_GATE"] = "specs.premium.domains.blockTransferGate";
  Specs["DOMAIN_ASSIGNMENT_FED_MIGRATION"] = "specs.premium.domains.domainsAssignmentFedMigration";
  Specs["TRANSFER_IN_VALIDATION_SERVICE"] = "transferInValidationService";
  return Specs;
}({});
//# sourceMappingURL=Specs.js.map